<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.name"
          :label="$t('global.name')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.namefr"
          :label="$t('global.namefr')"
          type="text"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="materialtypeSelectItems"
          v-model="item.materialType"
          :items="materialtypeSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('profile.material.types')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="materialmanufacturerSelectItems"
          v-model="item.materialManufacturer"
          :items="materialmanufacturerSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('profile.material.manufacturer')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="machineSelectItems"
          v-model="item.machines"
          :items="machineSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.machine')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="toolheadSelectItems"
          v-model="item.toolheads"
          :items="toolheadSelectItems"
          :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
          :label="$t('qualitycheck.product.toolhead')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="softwareSelectItems"
          v-model="item.softwares"
          :items="softwareSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('profile.software.software')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-radio-group v-model="item.public" row :label="$t('profile.public')">
          <v-radio
            :label="$t('global.true')"
            value="true"
          ></v-radio>
          <v-radio
            :label="$t('global.false')"
            value="false"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-radio-group v-model="item.experimental" row :label="$t('profile.experimental')">
          <v-radio
            :label="$t('global.true')"
            value="true"
          ></v-radio>
          <v-radio
            :label="$t('global.false')"
            value="false"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-radio-group v-model="item.newRelease" row :label="$t('profile.newrelease')">
          <v-radio
            :label="$t('global.true')"
            value="true"
          ></v-radio>
          <v-radio
            :label="$t('global.false')"
            value="false"
          ></v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-radio-group v-model="item.updateRelease" row :label="$t('profile.updaterelease')">
          <v-radio
            :label="$t('global.true')"
            value="true"
          ></v-radio>
          <v-radio
            :label="$t('global.false')"
            value="false"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'ProfilefileFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
      this.machineGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
      this.toolheadGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
      this.softwareGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc' });
      this.materialtypeGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
      this.materialmanufacturerGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
  },

  computed: {
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    ...mapFields('machine', {
      machineSelectItems: 'selectItems',
    }),
    ...mapFields('toolhead', {
      toolheadSelectItems: 'selectItems',
    }),
    ...mapFields('softwareversion', {
      softwareSelectItems: 'selectItems',
    }),
    ...mapFields('materialtype', {
      materialtypeSelectItems: 'selectItems',
    }),
    ...mapFields('materialmanufacturer', {
      materialmanufacturerSelectItems: 'selectItems',
    }),
  },
  methods: {
    ...mapActions({
      machineGetSelectItems: 'machine/fetchSelectItems',
      toolheadGetSelectItems: 'toolhead/fetchSelectItems',
      softwareGetSelectItems: 'softwareversion/fetchSelectItems',
      materialtypeGetSelectItems: 'materialtype/fetchSelectItems',
      materialmanufacturerGetSelectItems: 'materialmanufacturer/fetchSelectItems',
    }),
  }
};
</script>
